import { useForm } from 'react-hook-form';

export interface DocumentUploadFormValues {
    files: FileList;
}

export const useDocumentUploadForm = () => {
    return useForm<DocumentUploadFormValues>();
};
